import React, { Component } from "react";
import { Div, Text, Row, Col } from "atomize";

import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

export default class SalesCategory extends Component {
  render() {
    const { content } = this.props;
    return (
      <WebsiteContainer>
        <CustomContainer>
          <Div m={{t: "13.75rem"}}>
            <Div textAlign="center" m={{b: "3.5rem"}}>
              <Text textSize="display4" textWeight="bold" tag="h2" style={{lineHeight: "54px"}}>
                {content.heading}
              </Text>
              </Div>
            <Row>
              {content.categoryImages.map((image, index) => {
                return (
                <Col size="3" key={index} style={{marginBottom: ".8rem"}}>
                  <ImageLink link={image.imgLink}><Div bgImg={image.image} p={{b: "50%"}}  bgPos="center" bgSize="cover" /></ImageLink>
                </Col>
                );
              })}
            </Row>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    );
  }
}
